import React, { useState, useEffect, useRef } from "react";

import Loading from "../../../../Extra/Loading";
import SuccessMsg from "../../../../Extra/SuccessMsg";
import FailedMsg from "../../../../Extra/FailedMsg";
import axios from "axios";
import NoDataFound from "../../../../Extra/NoDataFound";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../../Utilitie";
import { BiSolidReport } from "react-icons/bi";

const BestEverPWITOHO = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [Data, setData] = useState([]);
  const tableRef = useRef();
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const section = [
    "AGD",
    "BINA",
    "ET",
    "KEQ",
    "KTKD",
    "MDVK",
    "MHDA/DHN",
    "MKP/ALD",
    "NKJ/BSP",
    "OHAN",
  ];
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefix}getPWIdataBestDataToHO?start=${startDate}&end=${endDate}`,
      );
      if (response.data.status === "ok") {
        setData(response.data.daterange.JUMBO);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const columnHead = [
    "AGDTOinterchange_date",
    "AGDTOvalue",
    "AGDHOinterchange_date",
    "AGDHOvalue",

    "BINATOinterchange_date",
    "BINATOvalue",
    "BINAHOinterchange_date",
    "BINAHOvalue",

    "ETTOinterchange_date",
    "ETTOvalue",
    "ETHOinterchange_date",
    "ETHOvalue",

    "KEQTOinterchange_date",
    "KEQTOvalue",
    "KEQHOinterchange_date",
    "KEQHOvalue",

    "KTKDTOinterchange_date",
    "KTKDTOvalue",
    "KTKDHOinterchange_date",
    "KTKDHOvalue",

    "MDVKTOinterchange_date",
    "MDVKTOvalue",
    "MDVKHOinterchange_date",
    "MDVKHOvalue",

    "MHDA/DHNTOinterchange_date",
    "MHDA/DHNTOvalue",
    "MHDA/DHNHOinterchange_date",
    "MHDA/DHNHOvalue",

    "MKP/ALDTOinterchange_date",
    "MKP/ALDTOvalue",
    "MKP/ALDHOinterchange_date",
    "MKP/ALDHOvalue",

    "NKJ/BSPTOinterchange_date",
    "NKJ/BSPTOvalue",
    "NKJ/BSPHOinterchange_date",
    "NKJ/BSPHOvalue",

    "OHANTOinterchange_date",
    "OHANTOvalue",
    "OHANHOinterchange_date",
    "OHANHOvalue",
  ];

  return (
    <div className="text-center mt-1">
      <div className="bg-dark text-white p-1 d-flex justify-content-between align-items-center papaDiv">
        <div>
          <h4 className="bg-dark text-white p-2 text-center">
            PWI Month Wise T/O & H/O Best Ever Report{" "}
          </h4>
        </div>
        <div className="d-flex">
          {" "}
          <b>From</b>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className=" me-1"
          />
          <b>To</b>
          <input
            type="date"
            value={endDate}
            max={getCurrentDate()}
            min={startDate}
            onChange={(e) => setEndDate(e.target.value)}
            className=" me-1"
          />
          <button
            className=" ms-1 btn btn-sm btn-outline-light"
            onClick={fetchData}
          >
            {" "}
            Fetch
          </button>
        </div>
      </div>

      <div className="table-responsive " style={{ fontSize: "12px" }}>
        <table
          ref={tableRef}
          className="table table-bordered table-striped mb-4 text-center align-middle"
        >
          <thead className="table-dark">
            <tr>
              <th rowSpan={2}>Sr No.</th>
              {section.map((head, index) => (
                <th
                  key={index}
                  colSpan={4}
                  style={{ border: "1px solid gray" }}
                >
                  {head.toUpperCase().replace(/_/g, " ")}
                </th>
              ))}
            </tr>
            <tr>
              {section.map((_, idx) => (
                <React.Fragment key={idx}>
                  <th>DATE</th>

                  <th>T/O</th>
                  <th>DATE</th>

                  <th>H/O</th>
                </React.Fragment>
              ))}
            </tr>
          </thead>

          <tbody>
            {Data && Data.length > 0 ? (
              Data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>{rowIndex + 1}</td>
                  {columnHead.map((o, i) => (
                    <td key={i} style={{ maxWidth: "90px " }}>
                      <div className=" p-2 fw-bold rounded ">
                        {o?.toLowerCase().includes("date")
                          ? row[o]?.slice(0, 10)
                          : row[o]}
                      </div>
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <td className="" colSpan={columnHead.length + 2}>
                <NoDataFound />
              </td>
            )}
          </tbody>
        </table>
      </div>

      <DownloadExcel
        tableRef={tableRef}
        fileName={`  PWI Month Wise T/O & H/O Best Ever Report - `}
      />
    </div>
  );
};

export default BestEverPWITOHO;
